import { render } from "./SubirPdf.vue?vue&type=template&id=8ffd67ca"
import script from "./SubirPdf.vue?vue&type=script&lang=js"
export * from "./SubirPdf.vue?vue&type=script&lang=js"

import "./SubirPdf.vue?vue&type=style&index=0&id=8ffd67ca&lang=css"

import exportComponent from "C:\\inetpub\\wwwroot\\autfis\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__